const namespace = window.VelotricBundle
if (!namespace?.["shell"]?.ready) { throw new Error("vl-bundle-shell.js must execute before vl-bundle-content.js") }
const sharedApi = namespace["shell"].api
if (!sharedApi) { throw new Error("Missing shell named API contract") }
export const $el = sharedApi["$el"]
export const $elParent = sharedApi["$elParent"]
export const $list = sharedApi["$list"]
export const appendElementToBody = sharedApi["appendElementToBody"]
export const capitalize = sharedApi["capitalize"]
export const createPortal = sharedApi["createPortal"]
export const createPrefetchLink = sharedApi["createPrefetchLink"]
export const delay = sharedApi["delay"]
export const getFocusTargets = sharedApi["getFocusTargets"]
export const getTargets = sharedApi["getTargets"]
export const isCurrentPageLink = sharedApi["isCurrentPageLink"]
export const isExternalLink = sharedApi["isExternalLink"]
export const isNotIframe = sharedApi["isNotIframe"]
export const isNotThemeStore = sharedApi["isNotThemeStore"]
export const isSafari = sharedApi["isSafari"]
export const registerComponent = sharedApi["registerComponent"]
export const removeCustomElementFromBody = sharedApi["removeCustomElementFromBody"]
export const stripHtml = sharedApi["stripHtml"]
export const transitionToPromise = sharedApi["transitionToPromise"]
export const upperCamelCaseToSnakeCase = sharedApi["upperCamelCaseToSnakeCase"]
export const viewportObserver = sharedApi["viewportObserver"]
export const whenDefined = sharedApi["whenDefined"]